import { useEffect, useState } from "react";
import { options } from "../../data/group-insurance";
import { SearchField } from "../../types/type";
import { GetProposalParams } from "../../api/gms/proposal/proposal-api-request";
import { DropdownOption } from "../../features/auth/auth-state";
import { getErrorMessage } from "../../utils/get-error-message.utils";
import { useGetAllRequestExtensionQuery } from "../../api/gms/proposal-extension/proposal-extension-api";
import { Option } from "../../features/it-user-forms/user-form-state";
import { useProposalTypeData } from "./use-proposal-type-data";
import { TotalPages, totalPages } from "../../features/pagination/pagination-inital-state";

export const useExtensionProposal = () => {

    const { isMarketingGMSDepartment } = useProposalTypeData()

    const includedOptionIds = [1, 2, 3, 4];
    const normalizedOptionsData: Option[] = options.filter((option) => includedOptionIds.includes(option.id)).map((option) => ({ 
        id: option.id, 
        value: option.value,
        name: option.name,
    }));

    const normalizedOptions: DropdownOption[] = options.filter((option) => includedOptionIds.includes(option.id)).map((option) => ({ 
        id: option.id,
        name: option.name,
    }));

    const [searchType, setSearchType] = useState<{ id: number; name: string; value: string; } | null>(normalizedOptionsData[0]);
    const selectedSearchType = searchType ? { id: searchType.id, name: searchType.name, } : null;
    const setSelectedSearchType = (type: { id: number; name: string } | null) => {
        if (!type) {
            setSearchType(null);
            return;
        }

        const option = normalizedOptionsData.find(o => o.id === type.id) ?? null;
        setSearchType(option);
    };
    const [searchValue, setSearchValue] = useState("");
    const [page, setPage] = useState(1);
    const [isTyping, setIsTyping] = useState(false);
    const [defaultTotalPages, setDefaultTotalPages] = useState<TotalPages>(totalPages[0])
    const [isPageSizeChanging, setIsPageSizeChanging] = useState(false);

    const params: GetProposalParams = { page, per_page: defaultTotalPages.value, };
    if (searchType && searchValue.trim()) {
        params[searchType.value as SearchField] = searchValue.trim();
    }

    const { 
        data: getExtensionProposalRequest, 
        isLoading: isLoadingGetExtensionProposalRequest, 
        isError: isErrorGetExtensionProposalRequest, 
        error: errorGetExtensionProposalRequest, 
        refetch: refetchGetExtensionProposalRequest, 
        isFetching: isFetchingGetExtensionProposalRequest 
    } = useGetAllRequestExtensionQuery(params, { skip: !isMarketingGMSDepartment });
    const errorMessageGetExtensionProposalRequest = getErrorMessage(errorGetExtensionProposalRequest)

    useEffect(() => {
        setIsTyping(true);

        const timer = setTimeout(() => {
            setIsTyping(false);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchValue]);

    useEffect(() => {
        setPage(1);
    }, [defaultTotalPages.value]);

    useEffect(() => {
        if (isPageSizeChanging && !isFetchingGetExtensionProposalRequest) {
            setIsPageSizeChanging(false);
        }
    }, [isFetchingGetExtensionProposalRequest, isPageSizeChanging]);

    const handleChangePageSize = (value: TotalPages) => {
        setIsPageSizeChanging(true);
        setDefaultTotalPages(value);
        setPage(1);
    };

    const handleReload = () => {
        setPage(1);
        refetchGetExtensionProposalRequest();
    };

    const loading =  isTyping || isLoadingGetExtensionProposalRequest || isPageSizeChanging

    return {
        getExtensionProposalRequest,
        loading,
        isErrorGetExtensionProposalRequest,

        normalizedOptions,
        errorMessage: errorMessageGetExtensionProposalRequest,
        searchType: selectedSearchType,
        setSearchType: setSelectedSearchType,
        searchValue,
        setSearchValue,
        setPage,

        pagedData: getExtensionProposalRequest?.data ?? [],
        handleReload,
        // filteredData,

        defaultTotalPages,
        setDefaultTotalPages,
        proposalDefaultPageSize: totalPages,
        handleChangePageSize
    }
}